import { Fuel } from '@/src/api/payg';
import { ReactComponent as ElecIcon } from '@/src/resources/illustration_elec.svg';
import { ReactComponent as GasIcon } from '@/src/resources/illustration_gas.svg';
import { Icon } from '@ovotech/element-v5';
import React, { ReactNode } from 'react';
import {
  StyledCard,
  StyledHeading,
  StyledHeadingRow,
  StyledInfoButton,
} from './styles';

interface Props {
  fuel: Fuel;
  children: ReactNode;
  onInfoClick?: () => void;
}

export const BaseBalanceCard = ({ fuel, children, onInfoClick }: Props) => (
  <StyledCard
    heading={
      <StyledHeadingRow>
        <StyledHeading>{fuel}</StyledHeading>
        {onInfoClick && (
          <StyledInfoButton
            type="button"
            aria-label={`${fuel} information`}
            onClick={onInfoClick}
          >
            <Icon name="info" size={20} />
          </StyledInfoButton>
        )}
      </StyledHeadingRow>
    }
    icon={fuel === Fuel.GAS ? <GasIcon /> : <ElecIcon />}
  >
    {children}
  </StyledCard>
);
